import React from 'react';
import BaseIcon from './BaseIcon';

interface ShoppingCartIconProps {
  className?: string;
}

const ShoppingCartIcon: React.FC<ShoppingCartIconProps> = ({ className = "w-5 h-5" }) => (
  <BaseIcon className={className} strokeWidth={1.5}>
    <circle cx="9" cy="21" r="1"></circle>
    <circle cx="20" cy="21" r="1"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  </BaseIcon>
);

export default ShoppingCartIcon;
